(function () {
  const root = document.querySelector('[data-or-cart-also-bought]');
  if (!root) return;

  root.addEventListener('click', function (event) {
    const button = event.target.closest('[data-or-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.getAttribute('data-or-add');
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          button.setAttribute('aria-disabled', 'false');
          button.classList.remove('is-loading');
          window.alert(result.data.description || result.data.message || 'Could not add to cart');
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        button.setAttribute('aria-disabled', 'false');
        button.classList.remove('is-loading');
      });
  });
})();
